import { QsHttpService } from '../core/http/qs-http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { EContactType, IContactUsFormValue } from './contact-us.interface';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(
    private readonly http: QsHttpService,
  ) { }

  public postContactUsForm(data: { data: Partial<IContactUsFormValue> }, contactType: EContactType): Observable<Partial<IContactUsFormValue>> {
    const dataObj = data;

    if (Array.isArray(data.data.topicsOfInterest)) {
      dataObj.data.topicsOfInterest = data.data.topicsOfInterest?.join(',');
    }

    if (Array.isArray(data.data.referrer)) {
      dataObj.data.referrer = data.data.referrer?.join(',');
    }

    if (data.data.newsletterOptIn === null) {
      dataObj.data.newsletterOptIn = false;
    }

    if (contactType) {
      dataObj.data.contactType = contactType;
    }

    return this.http.post<Partial<IContactUsFormValue>>('/contact-requests', dataObj);
  }
}
